import { isEmpty } from 'lodash'

import { SelectPayments } from './SelectPayments'
import { SelectTickets } from './SelectTickets'
import { SelectRefundDestination } from 'features/Bookings/components/CancelTicketsModal/SelectRefundDestination'
import { Column } from 'components/v2/Column'
import { Row } from 'components/v2/Row'
import { ReactElement } from 'react'

export const PartialCancellation = ({
  booking,
  paidPayments,
  selectedTicketsIds,
  setSelectedTicketsIds,
  formProps
}: TSFixMe): ReactElement => {
  return (
    <div>
      <SelectTickets
        booking={booking}
        selectedTicketsIds={selectedTicketsIds}
        setSelectedTicketsIds={setSelectedTicketsIds}
      />
      {!isEmpty(paidPayments) && <SelectPayments booking={booking} paidPayments={paidPayments} formProps={formProps} />}
    </div>
  )
}

export const PartialCancellationV2 = ({
  booking,
  paidPayments,
  selectedTicketsIds,
  setSelectedTicketsIds,
  canRefundToKredits,
  refundDestination,
  setRefundDestination
}: TSFixMe): ReactElement => {
  return (
    <div>
      {paidPayments.length > 0 && (
        <Row>
          <Column>
            <SelectRefundDestination
              canRefundToKredits={canRefundToKredits}
              refundDestination={refundDestination}
              setRefundDestination={setRefundDestination}
              last4={paidPayments[0]?.last4 ?? ''}
              paidPayments={paidPayments}
              bookingRefunds={booking.refunds}
            />
          </Column>
        </Row>
      )}
      <SelectTickets
        booking={booking}
        selectedTicketsIds={selectedTicketsIds}
        setSelectedTicketsIds={setSelectedTicketsIds}
      />
    </div>
  )
}
